import { InitSearchFieldTime } from "../times/TimeFactory";

export abstract class TrackSessionStart {
  static set sended(value: boolean) {
    window.o_util.cookie.set("o_squirrel_sessionStart_sended", value + "");
  }

  static get isSended(): boolean {
    return window.o_util.cookie.get("o_squirrel_sessionStart_sended") == "true";
  }

  static get sessionStart(): number | undefined {
    const sessionStart = window.o_util.cookie.get("o_squirrel_sessionStart");
    if (!sessionStart) {
      return;
    }
    return Number(sessionStart);
  }

  static updateLabel(): number | undefined {
    let initialSearchBoxTime: number | undefined = undefined;
    const sessionStart = Number(window.o_util.cookie.get("o_squirrel_sessionStart"));
    const currentTime = new Date().getTime();
    const sessionTime = currentTime - sessionStart;
    const ttl = 7200000;
    if (sessionTime > ttl) {
      window.o_util.cookie.set("o_squirrel_sessionStart", InitSearchFieldTime.navigationStart + "");
      this.sended = false;
    }

    if (!this.isSended && InitSearchFieldTime.countMeasures > 0) {
      initialSearchBoxTime = (InitSearchFieldTime.measurePerfEntries.pop() as PerformanceEntry).duration;
      this.sended = true;
    }
    return initialSearchBoxTime;
  }

  static init() {
    if (this.isCookieBannerEnabled && !this.sessionStart) {
      window.o_util.cookie.set("o_squirrel_sessionStart", InitSearchFieldTime.navigationStart + "");
      TrackSessionStart.sended = false;
    }
  }

  protected static get isCookieBannerEnabled(): boolean {
    if (window.o_util && window.o_util.cookie && window.o_util.cookie.get) {
      return window.o_util.cookie.get("cb") == "1";
    }
    return false;
  }
}
